import { render, staticRenderFns } from "./CheckSvg.vue?vue&type=template&id=00f50ae4"
import script from "./CheckSvg.vue?vue&type=script&lang=js"
export * from "./CheckSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports